module.exports = "/dist/1e65e7e4eaaa9cda89cdf3860e41a401.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-400italic.woff
// module id = 154
// module chunks = 0